<template>
    <ValidationObserver v-slot="{ handleSubmit }">
        <form
            @submit.prevent="handleSubmit(downloadCode)"
            class="flex flex-col w-full py-4 md:px-4"
        >
            <div id="OptHotel" class="form-folio">
                <div class="flex -mx-2">
                    <div class="w-1/2 my-2 mx-2">
                        <ValidationProvider
                            :name="$t('Forms.hotel')"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <label class="font-bold" for="hotel"
                                >{{ $t("Forms.hotel") }}:</label
                            >
                            <select
                                id="hotel"
                                v-model="GetPhotos.HotelId"
                                class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg"
                            >
                                <option :value="null" selected="selected">
                                    {{ $t("Forms.choose_option") }}
                                </option>

                                <template v-for="(item, idx) in GetParks">
                                    <option
                                        :key="idx"
                                        :value="item.ParkId"
                                        v-html="item.ParkName"
                                        v-if="item.IsHotel"
                                    ></option>
                                </template>
                            </select>
                            <p class="txt-error text-red text-xs italic">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                    </div>
                    <!-- DATE: {{ DateGood }} -->
                    <div class="w-1/2 my-2 mx-2">
                        <ValidationProvider
                            :name="$t('Forms.arrival_date')"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <label class="font-bold" for="ArrivalDate"
                                >{{ $t("Forms.arrival_date") }}:</label
                            >
                            <date-picker
                                id="ArrivalDate"
                                v-model="GetPhotos.ArrivalDate"
                                type="date"
                                :default-value="new Date()"
                                placeholder="YYYY-MM-DD"
                                :disabled-date="
                                    disabledBeforeTodayAndAfterAWeek
                                "
                                value-type="format"
                                format="YYYY-MM-DD"
                                :editable="false"
                            >
                            </date-picker>

                            <p class="txt-error text-red text-xs italic">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                    </div>
                </div>

                <div class="flex -mx-2">
                    <div class="w-1/2 my-2 mx-2">
                        <ValidationProvider
                            :name="$t('Forms.departure_date')"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <label class="font-bold" for="DepartureDate"
                                >{{ $t("Forms.departure_date") }}:</label
                            >
                            <date-picker
                                id="DepartureDate"
                                v-model="GetPhotos.DepartureDate"
                                type="date"
                                :default-value="new Date()"
                                placeholder="YYYY-MM-DD"
                                :disabled-date="
                                    disabledBeforeTodayAndAfterAWeek
                                "
                                value-type="format"
                                format="YYYY-MM-DD"
                                :editable="false"
                            >
                            </date-picker>

                            <p class="txt-error text-red text-xs italic">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                    </div>

                    <div class="w-1/2 my-2 mx-2">
                        <ValidationProvider
                            :name="$t('Forms.Room')"
                            rules="required|min:4|max:6"
                            v-slot="{ errors }"
                        >
                            <label class="font-bold" for="Room"
                                >{{ $t("Forms.Room") }}:</label
                            >
                            <input
                                id="Room"
                                type="text"
                                v-model="GetPhotos.Room"
                                :maxlength="6"
                                @keypress="onlyNumber"
                                :placeholder="$t('Forms.Room')"
                                class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg"
                            />
                            <p class="txt-error text-red text-xs italic">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                        <p
                            class="txt-error text-red text-xs italic"
                            v-if="errorLogin.Room"
                        >
                            {{ responseErrors.Room[0] }}
                        </p>
                    </div>
                </div>

                <p
                    class="txt-error text-red text-xs italic"
                    v-if="msgApi.error"
                >
                    {{ msgApi.message }}
                </p>
            </div>

            <!-- <p class="text-sm text-newxcaret-blue cursor-pointer">
            +Agregar otro folio
          </p> -->

            <button
                type="submit"
                class="w-full flex justify-center rounded-full py-3 px-4 mb-1 mt-2 bg-red-500 text-white cursor-pointer font-semibold mx-auto"
            >
                {{ $t("Forms.add_room") }}
            </button>
        </form>
    </ValidationObserver>
</template>

<script>
import { GetApiErrorMessage } from "@helpers/apiErrorHelper";
let code = document.documentElement.lang;
import "../validators/index";

import moment from "moment";

import AlbumsByRoomMix from "../mixins/albums/GetAlbumsByRoom";
import CartMix from "../mixins/Cart";
import UserMix from "../mixins/methodUser";
import MultimediaMix from "../mixins/Multimedia";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";
DatePicker.locale(code);

export default {
    props: ["t", "redirect"],
    mixins: [AlbumsByRoomMix, UserMix, MultimediaMix, CartMix],
    components: {
        DatePicker,
    },
    data: () => ({
        firstName: "",
        lastName: "",
        email: "",
        errors: [],
        downloadCodes: [],
        option: 0,
        loading: false,
        screenLoading: false,
        lastInsertItem: [],
        GetPhotos: {
            question: "",
            JoinedCode: "",
            ParkId: null,
            visitDate: "",
            tag: "",
            HotelId: null,
            Room: "",
            ArrivalDate: "",
            DepartureDate: "",
        },
        Parks: [{ value: null, text: "Seleccione una opción" }],
        Hotels: [{ value: null, text: "Seleccione una opción" }],
    }),
    computed: {
        GetParks() {
            return this.$store.getters.GetParks;
        },
        DateGood() {
            this.formatDate(this.GetPhotos.ArrivalDate);
        },
    },
    methods: {
        formatDate(date) {
            return moment(String(date)).format("YYYY-MM-DD");
        },
        hasCode() {
            // Verificamos si el tag fue agregado anteriormente
            return Object.values(this.$store.state.albumes).some(
                (element) =>
                    element.code == this.GetPhotos.Room && element.Type == 2
            );
        },
        buildRoom() {
            let room = this.GetPhotos.Room;
            const parkId = this.GetPhotos.HotelId;
            const parkDetail = this.getParkDetail(parkId);
            const roomPrefix = parkDetail.RoomPrefix;
            room = parseInt(roomPrefix + room);
            
            return room.toString();
        },
        async downloadCode() {
            try {
                this.msgApi.error = false;
                this.msgApi.message = "";
                this.$store.dispatch("setLoading", true);

                if (this.hasCode()) {
                    Vue.$toast.open({
                        message: this.$t("Forms.exist_code"),
                        type: "info",
                    });

                    this.msgApi.error = true;
                    this.msgApi.message = this.$t("Forms.exist_code");
                    return;
                }

                // Verificamos si el Room le agregaron el room prefix si no se lo agregamos automaticamente
                const room = this.buildRoom();
                const arrivalDate = this.GetPhotos.ArrivalDate.toString();
                const departureDate = this.GetPhotos.DepartureDate.toString();

                await this.GetAlbumByRoom(room, arrivalDate, departureDate);
                // Close modal add new Tag
                this.$store.dispatch("setModalAddAlbum", false);

            } catch (error) {
                this.$store.dispatch("setLoading", false);
                
                const message = GetApiErrorMessage(
                    error,
                    this.$t("messages.album_error_add")
                );
                this.msgApi.message = message;

                Vue.$toast.open({
                    message,
                    type: "error",
                });

                this.msgApi.error = true;
            } finally {
                this.$store.dispatch("setLoading", false);
            }
        },
        saveDownloadCode(data) {
            //Miramos si ya hemos guardado algo anteriormente.
            let newCodes;
            let currentCode = "";
            let recoveredData = this.getAlbumes;

            if (this.GetPhotos.question == 1) {
                currentCode = this.GetPhotos.tag;
                newCodes = {
                    code: this.GetPhotos.tag,
                    type: this.GetPhotos.question,
                    visitDate: this.GetPhotos.visitDate,
                    ParkId: this.GetPhotos.ParkId,
                };
            } else if (this.GetPhotos.question == 2) {
                currentCode = this.GetPhotos.Room;
                newCodes = {
                    code: this.GetPhotos.Room,
                    type: this.GetPhotos.question,
                    ArrivalDate: this.GetPhotos.ArrivalDate,
                    DepartureDate: this.GetPhotos.DepartureDate,
                    ParkId: this.GetPhotos.HotelId,
                };
            } else {
                currentCode = this.GetPhotos.JoinedCode;
                newCodes = {
                    code: this.GetPhotos.JoinedCode,
                    type: this.GetPhotos.question,
                };
            }

            if (recoveredData == null || !recoveredData.length) {
                this.setCodes(newCodes);
                this.GetPhotos.JoinedCode = "";
                
                return false;
            } else {
                //Asegurate que lo que guardes es realmente un array.
                if (!this.existCode(recoveredData, currentCode)) {
                    this.setCodes(newCodes);
                    this.GetPhotos.JoinedCode = "";
                    
                    return false;
                } else {
                    return true;
                }
            }
        },
        existCode(data, valueFind) {
            let exist = false;
            data.map(function (item) {
                if (item.code == valueFind) exist = true;
            });

            return exist;
        },
        onChangeQuestion(event) {},
        // Metodos para agregar los codigos a un arreglo.
        addDownloadCode() {
            this.downloadCodes.push(this.GetPhotos.JoinedCode);
            this.GetPhotos.JoinedCode = "";
        },
        clearFormSearch() {
            this.GetPhotos.JoinedCode = "";
            this.GetPhotos.ParkId = null;
            this.GetPhotos.visitDate = "";
            this.GetPhotos.tag = "";
            this.HotelId = null;
            this.Room = "";
            this.ArrivalDate = "";
            this.DepartureDate = "";
        },
    },
    created() {},
    mounted() {},
};
</script>
